// extracted by mini-css-extract-plugin
export default {"wrap":"jp-z","logoContainer":"kp-z","brandImg":"lp-z","logoImg":"mp-z","logoButton":"np-z"};